import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { trackPromise } from "react-promise-tracker";
import { FaPlusSquare, FaSearch, FaUserEdit, FaTrash } from 'react-icons/fa';
import { BsTable, BsGraphUp } from "react-icons/bs";
import { styles } from './BOUsersStyles';
import GestaoAcessos from './GestaoAcessos';
import { DEBUG, SOFTDATANODEJS } from '../../config';

const UsersTable = () => {
    const [users, setUsers] = useState([]);
    const [listaGrupos, setListaGrupos] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(50);

    const [showAcessosModal, setShowAcessosModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showCreateModal, setShowCreateModal] = useState(false);

    const [selectedUser, setSelectedUser] = useState(null);
    const [editUserData, setEditUserData] = useState(null);
    const [accessType, setAccessType] = useState('');

    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const [createUserData, setCreateUserData] = useState({
        nome: '', login: '', pin: '', perfil: 10, estado: 1, groupName: 'AnyGroupName', grupos: [],
        acessoTables: true, acessoReports: true
    });

    useEffect(() => {
        fetchUsers();
        fetchGrupos();
    }, []);

    const fetchUsers = async () => {
        try {
            if (DEBUG) {
                console.log("SOFTDATANODEJS =", SOFTDATANODEJS);
                console.log("URL =", `${SOFTDATANODEJS}/mongodb/perfis`);
            }
            const response = await trackPromise(axios.get(`${SOFTDATANODEJS}/mongodb/perfis`));
            setUsers(response.data);
        } catch (error) {
            console.error("ERRO [BackOffice, BOUsers, UsersTable, fetchUsers]: Falha ao obter resultados da operação.", error);
            setErrorMessage("Erro ao buscar a lista de utilizadores. Por favor, contate o serviço técnico da DATA E.");
            setShowErrorModal(true);
        }
    };

    const fetchGrupos = async () => {
        try {
            const response = await axios.get(`${SOFTDATANODEJS}/mysql/grupos`);
            setListaGrupos(response.data);
        } catch (error) {
            console.error("ERRO [BackOffice, BOUsers, UsersTable, fetchGrupos]: Falha ao obter resultados da operação.", error);
            setErrorMessage("Erro ao buscar a lista de grupos do sistema.");
            setShowErrorModal(true);
        }
    };

    const getNomePerfil = (id) => {
        switch (Number(id)) {
            case 1: return "ADMIN"; case 5: return "TÉCNICO"; case 10: return "CONSULTA"; case 11: return "DEMO"; default: return "N/D";
        }
    };

    const filteredUsers = users.filter(u =>
        u.nome?.toLowerCase().includes(searchTerm.toLowerCase()) || u.login?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const totalItems = filteredUsers.length;
    const totalPages = Math.ceil(totalItems / pageSize);
    const currentItems = filteredUsers.slice((currentPage - 1) * pageSize, currentPage * pageSize);

    const handleGroupToggle = (grupoId, isCreate) => {
        if (isCreate) {
            const prev = createUserData.grupos;
            setCreateUserData({ ...createUserData, grupos: prev.includes(grupoId) ? prev.filter(id => id !== grupoId) : [...prev, grupoId] });
        } else {
            const prev = editUserData.grupos;
            setEditUserData({ ...editUserData, grupos: prev.includes(grupoId) ? prev.filter(id => id !== grupoId) : [...prev, grupoId] });
        }
    };

    const handleOpenAcessos = (user, tipo) => {
        if (tipo === 'tables' && !user._id) {
            setErrorMessage("Este utilizador não tem perfil no MongoDB (Tables).");
            return setShowErrorModal(true);
        }
        if (tipo === 'report' && !user.mysql_id) {
            setErrorMessage("Este utilizador não tem perfil no MySQL (Reports).");
            return setShowErrorModal(true);
        }
        setSelectedUser(user);
        setAccessType(tipo);
        setShowAcessosModal(true);
    };

    const handleDeleteClick = (user) => { setSelectedUser(user); setShowDeleteModal(true); };

    const handleEditClick = async (user) => {
        let userGruposIds = [];
        try {
            if (user.mysql_id) {
                const res = await trackPromise(axios.get(`${SOFTDATANODEJS}/mysql/perfis/${user.mysql_id}/grupos`));
                userGruposIds = res.data;
            }
        } catch (err) {
            setErrorMessage("Aviso: Não foi possível carregar os grupos previamente associados a este utilizador.");
            setShowErrorModal(true);
        }

        setEditUserData({
            mysql_id: user.mysql_id,
            _id: user._id,
            nome: user.nome || '',
            login: user.login || '',
            pin: '',
            perfil: user.perfil || 10,
            estado: user.estado,
            groupName: user.group?.name || 'AnyGroupName',
            grupos: userGruposIds,
            acessoTables: !!user._id,
            // Se ele tem estado 1, assumimos que tem Acesso Reports (visto que a gestão de Acesso Tables é definida pelo _id)
            acessoReports: user.estado === 1
        });
        setShowEditModal(true);
    };

    const handleCreateClick = () => {
        setCreateUserData({ nome: '', login: '', pin: '', perfil: 10, estado: 1, groupName: 'AnyGroupName', grupos: [], acessoTables: true, acessoReports: true });
        setShowCreateModal(true);
    };

    const handleCreateSave = async () => {
        if (!createUserData.nome || !createUserData.login || !createUserData.pin) {
            setErrorMessage("O Nome, Login e a Password (PIN) são obrigatórios!");
            return setShowErrorModal(true);
        }

        const estadoFinal = createUserData.acessoReports ? 1 : 0;
        const payload = { ...createUserData, estado: estadoFinal };

        try {
            const response = await trackPromise(axios.post(`${SOFTDATANODEJS}/mongodb/perfis`, payload));
            const novoMysqlId = response.data.mysql_id;

            if (createUserData.acessoReports && createUserData.grupos.length > 0 && novoMysqlId) {
                await trackPromise(axios.put(`${SOFTDATANODEJS}/mysql/perfis/${novoMysqlId}/grupos`, { grupos: createUserData.grupos }));
            }

            setShowCreateModal(false);
            fetchUsers();

            setSuccessMessage("Utilizador criado com sucesso!");
            setShowSuccessModal(true);

        } catch (error) {
            const msg = error.response?.data?.error || "Erro ao criar utilizador.";
            setErrorMessage(msg);
            setShowErrorModal(true);
        }
    };

    const handleSaveEdit = async () => {
        const estadoFinal = editUserData.acessoReports ? 1 : 0;
        const payload = { ...editUserData, estado: estadoFinal };

        try {
            const response = await trackPromise(axios.put(`${SOFTDATANODEJS}/mongodb/perfis/update`, payload));
            const finalMysqlId = response.data.mysql_id;

            // Atualiza os grupos (Se ele tirou os Reports, apagamos os grupos enviando array vazio)
            if (finalMysqlId) {
                const gruposAEnviar = editUserData.acessoReports ? editUserData.grupos : [];
                await trackPromise(axios.put(`${SOFTDATANODEJS}/mysql/perfis/${finalMysqlId}/grupos`, { grupos: gruposAEnviar }));
            }

            setShowEditModal(false);
            fetchUsers();

            setSuccessMessage("Utilizador atualizado com sucesso!");
            setShowSuccessModal(true);
        } catch (error) {
            const msg = error.response?.data?.error || "Erro ao editar utilizador.";
            setErrorMessage(msg);
            setShowErrorModal(true);
        }
    };

    const confirmDelete = async () => {
        try {
            const mongoId = selectedUser._id || 'null';
            const mysqlId = selectedUser.mysql_id || 'null';
            await trackPromise(axios.delete(`${SOFTDATANODEJS}/mongodb/perfis/${mongoId}?mysql_id=${mysqlId}`));
            setShowDeleteModal(false);
            fetchUsers();
            setSuccessMessage("Utilizador eliminado com sucesso!");
            setShowSuccessModal(true);
        } catch (error) {
            const msg = error.response?.data?.error || "Erro ao eliminar utilizador.";
            setErrorMessage(msg);
            setShowErrorModal(true);
        }
    };

    return (
        <div style={styles.pageBackground}>
            <div style={styles.container}>
                <div style={styles.headerBar}>
                    <div style={{ flex: 1 }}></div>
                    <h2 style={styles.mainTitle}>Gestão de Utilizadores (Portal)</h2>
                    <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end', paddingRight: '10px' }}>
                        <button
                            style={{
                                ...styles.footerBtn,
                                height: '34px',
                                boxSizing: 'border-box',
                                padding: '0 15px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                background: '#28a745',
                                color: '#fff',
                                border: 'none',
                                fontWeight: 'bold',
                                margin: 0,
                                whiteSpace: 'nowrap'
                            }}
                            onClick={handleCreateClick}
                        >
                            <FaPlusSquare size={16} />
                            <span>Novo Utilizador</span>
                        </button>
                    </div>
                </div>

                <div style={styles.controls}>
                    <div style={styles.leftControls}>
                        <div style={styles.searchBox}>
                            <FaSearch style={{ color: '#666', marginRight: '5px' }} />
                            <input placeholder="Pesquisar..." value={searchTerm} onChange={e => { setSearchTerm(e.target.value); setCurrentPage(1); }} style={styles.searchInput} />
                        </div>
                    </div>
                    <div style={styles.paginationGroup}>
                        <button style={styles.navBtn} disabled={currentPage === 1} onClick={() => setCurrentPage(p => p - 1)}>Anterior</button>
                        <span style={styles.pageIndicator}>Pág. {currentPage} de {totalPages || 1}</span>
                        <button style={styles.navBtn} disabled={currentPage >= totalPages} onClick={() => setCurrentPage(p => p + 1)}>Próximo</button>
                        <select style={styles.select} value={pageSize} onChange={(e) => { setPageSize(Number(e.target.value)); setCurrentPage(1); }}>
                            <option value={20}>20</option><option value={50}>50</option><option value={100}>100</option>
                        </select>
                    </div>
                </div>

                <div style={styles.tableContainer}>
                    <table style={styles.table}>
                        <thead style={styles.theadSticky}>
                            <tr style={styles.theadRow}>
                                <th style={{ ...styles.th, textAlign: 'left' }}>Nome</th>
                                <th style={{ ...styles.th, width: '150px' }}>Login</th>
                                <th style={{ ...styles.th, width: '120px' }}>Perfil</th>
                                <th style={{ ...styles.th, width: '170px' }}>Acções</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentItems.length === 0 ? (
                                <tr>
                                    <td
                                        colSpan="4"
                                        style={{
                                            padding: '20px',
                                            textAlign: 'center',
                                            color: '#333',
                                            backgroundColor: '#ffffff'
                                        }}
                                    >
                                        Nenhum utilizador encontrado.
                                    </td>
                                </tr>
                            ) : (
                                currentItems.map((user, index) => (
                                    <tr
                                        key={user.mysql_id || user._id}
                                        style={{
                                            ...styles.dataRow,
                                            backgroundColor: index % 2 === 0 ? '#ffffff' : '#f2f4f7'
                                        }}
                                    >
                                        <td style={{ ...styles.td, textAlign: 'left', fontWeight: 'bold' }}>{user.nome}</td>
                                        <td style={styles.td}>{user.login}</td>
                                        <td style={styles.td}>{getNomePerfil(user.perfil)}</td>
                                        <td style={styles.tdActions}>
                                            <button
                                                style={{ ...styles.iconBtn, opacity: user._id ? 1 : 0.3 }}
                                                disabled={!user._id}
                                                onClick={() => handleOpenAcessos(user, 'tables')}
                                                title="Gerir Acessos Tables"
                                            >
                                                <BsTable style={{ color: '#E67E22' }} />
                                            </button>

                                            <button
                                                style={{ ...styles.iconBtn, opacity: user.estado === 1 ? 1 : 0.3 }}
                                                disabled={user.estado !== 1}
                                                onClick={() => handleOpenAcessos(user, 'report')}
                                                title="Gerir Acessos Report"
                                            >
                                                <BsGraphUp style={{ color: '#17a2b8' }} />
                                            </button>

                                            <button
                                                style={styles.iconBtn}
                                                onClick={() => handleEditClick(user)}
                                                title="Editar Utilizador"
                                            >
                                                <FaUserEdit style={{ color: '#005c75' }} />
                                            </button>

                                            <button
                                                style={styles.iconBtn}
                                                onClick={() => handleDeleteClick(user)}
                                                title="Eliminar"
                                            >
                                                <FaTrash style={{ color: '#dc3545' }} />
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* MODAL: GERIR ACESSOS */}
            {showAcessosModal && selectedUser && (
                <GestaoAcessos perfilId={selectedUser._id} perfilAtual={selectedUser} tipoAcesso={accessType} onClose={() => setShowAcessosModal(false)} onSaved={() => { setShowAcessosModal(false); fetchUsers(); }} />
            )}

            {/* MODAL: NOVO UTILIZADOR */}
            {showCreateModal && (
                <div style={styles.modalOverlay}>
                    <div style={styles.modalContent}>
                        <h2 style={styles.modalTitle}>Criar Novo Utilizador</h2>
                        <div style={styles.modalScroll}>
                            <table style={styles.infoTable}>
                                <tbody>
                                    <tr>
                                        <td style={styles.infoLabel}>Nome Real:</td>
                                        <td style={styles.infoVal}>
                                            <input style={styles.modalInput} value={createUserData.nome} onChange={(e) => setCreateUserData({ ...createUserData, nome: e.target.value })} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={styles.infoLabel}>Username (Login):</td>
                                        <td style={styles.infoVal}>
                                            <input style={styles.modalInput} value={createUserData.login} onChange={(e) => setCreateUserData({ ...createUserData, login: e.target.value })} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={styles.infoLabel}>Password (PIN):</td>
                                        <td style={styles.infoVal}>
                                            <input type="text" style={styles.modalInput} value={createUserData.pin} onChange={(e) => setCreateUserData({ ...createUserData, pin: e.target.value })} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={styles.infoLabel}>Perfil:</td>
                                        <td style={styles.infoVal}>
                                            <select style={styles.modalInput} value={createUserData.perfil} onChange={(e) => setCreateUserData({ ...createUserData, perfil: Number(e.target.value) })}>
                                                <option value={1}>ADMIN</option><option value={5}>TÉCNICO</option><option value={10}>CONSULTA</option><option value={11}>DEMO</option>
                                            </select>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={styles.infoLabel}>Plataformas:</td>
                                        <td style={styles.infoVal}>
                                            <label style={{ display: 'inline-flex', alignItems: 'center', marginRight: '15px', cursor: 'pointer', color: '#333' }}>
                                                <input type="checkbox" checked={createUserData.acessoTables} onChange={(e) => setCreateUserData({ ...createUserData, acessoTables: e.target.checked })} style={{ marginRight: '5px' }} />
                                                <BsTable style={{ color: '#E67E22', marginRight: '5px' }} /> Tables
                                            </label>
                                            <label style={{ display: 'inline-flex', alignItems: 'center', cursor: 'pointer', color: '#333' }}>
                                                <input type="checkbox" checked={createUserData.acessoReports} onChange={(e) => setCreateUserData({ ...createUserData, acessoReports: e.target.checked })} style={{ marginRight: '5px' }} />
                                                <BsGraphUp style={{ color: '#17a2b8', marginRight: '5px' }} /> Reports
                                            </label>
                                        </td>
                                    </tr>
                                    {createUserData.acessoReports && (
                                        <tr>
                                            <td style={{ ...styles.infoLabel, verticalAlign: 'top' }}>Grupos (Reports):</td>
                                            <td style={styles.infoVal}>
                                                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '8px', padding: '10px', backgroundColor: '#fff', border: '1px solid #ccc' }}>
                                                    {listaGrupos.map(g => (
                                                        <label key={g.id} style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', fontSize: '12px', color: '#333', margin: 0 }}>
                                                            <input type="checkbox" style={{ marginRight: '5px' }} checked={createUserData.grupos ? createUserData.grupos.includes(g.id) : false} onChange={() => handleGroupToggle(g.id, true)} /> {g.nome}
                                                        </label>
                                                    ))}
                                                    {listaGrupos.length === 0 && <span style={{ color: '#999', gridColumn: 'span 3' }}>Nenhum grupo encontrado.</span>}
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                        <div style={styles.modalFooter}>
                            <button style={{ ...styles.footerBtn, background: '#28a745', color: '#fff' }} onClick={handleCreateSave}>Criar Utilizador</button>
                            <button style={styles.footerBtn} onClick={() => setShowCreateModal(false)}>Cancelar</button>
                        </div>
                    </div>
                </div>
            )}

            {/* MODAL: EDITAR UTILIZADOR */}
            {showEditModal && editUserData && (
                <div style={styles.modalOverlay}>
                    <div style={styles.modalContent}>
                        <h2 style={styles.modalTitle}>Editar Utilizador</h2>
                        <div style={styles.modalScroll}>
                            <table style={styles.infoTable}>
                                <tbody>
                                    <tr>
                                        <td style={styles.infoLabel}>Nome Real:</td>
                                        <td style={styles.infoVal}>
                                            <input style={styles.modalInput} value={editUserData.nome} onChange={(e) => setEditUserData({ ...editUserData, nome: e.target.value })} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={styles.infoLabel}>Username (Login):</td>
                                        <td style={styles.infoVal}>
                                            <input style={styles.modalInput} value={editUserData.login} onChange={(e) => setEditUserData({ ...editUserData, login: e.target.value })} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={styles.infoLabel}>Nova Password (PIN):</td>
                                        <td style={styles.infoVal}>
                                            <input type="text" placeholder="Deixe em branco para manter a atual" style={styles.modalInput} value={editUserData.pin} onChange={(e) => setEditUserData({ ...editUserData, pin: e.target.value })} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={styles.infoLabel}>Perfil:</td>
                                        <td style={styles.infoVal}>
                                            <select style={styles.modalInput} value={editUserData.perfil} onChange={(e) => setEditUserData({ ...editUserData, perfil: Number(e.target.value) })}>
                                                <option value={1}>ADMIN</option><option value={5}>TÉCNICO</option><option value={10}>CONSULTA</option><option value={11}>DEMO</option>
                                            </select>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={styles.infoLabel}>Plataformas:</td>
                                        <td style={styles.infoVal}>
                                            <label style={{ display: 'inline-flex', alignItems: 'center', marginRight: '15px', cursor: 'pointer', color: '#333' }}>
                                                <input type="checkbox" checked={editUserData.acessoTables} onChange={(e) => setEditUserData({ ...editUserData, acessoTables: e.target.checked })} style={{ marginRight: '5px' }} />
                                                <BsTable style={{ color: '#E67E22', marginRight: '5px' }} /> Tables
                                            </label>
                                            <label style={{ display: 'inline-flex', alignItems: 'center', cursor: 'pointer', color: '#333' }}>
                                                <input type="checkbox" checked={editUserData.acessoReports} onChange={(e) => setEditUserData({ ...editUserData, acessoReports: e.target.checked })} style={{ marginRight: '5px' }} />
                                                <BsGraphUp style={{ color: '#17a2b8', marginRight: '5px' }} /> Reports
                                            </label>
                                        </td>
                                    </tr>
                                    {editUserData.acessoReports && (
                                        <tr>
                                            <td style={{ ...styles.infoLabel, verticalAlign: 'top' }}>Grupos (Reports):</td>
                                            <td style={styles.infoVal}>
                                                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '8px', padding: '10px', backgroundColor: '#fff', border: '1px solid #ccc' }}>
                                                    {listaGrupos.map(g => (
                                                        <label key={g.id} style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', fontSize: '12px', color: '#333', margin: 0 }}>
                                                            <input type="checkbox" style={{ marginRight: '5px' }} checked={editUserData.grupos ? editUserData.grupos.includes(g.id) : false} onChange={() => handleGroupToggle(g.id, false)} /> {g.nome}
                                                        </label>
                                                    ))}
                                                    {listaGrupos.length === 0 && <span style={{ color: '#999', gridColumn: 'span 3' }}>Nenhum grupo encontrado.</span>}
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                        <div style={styles.modalFooter}>
                            <button style={{ ...styles.footerBtn, background: '#005c75', color: '#fff' }} onClick={handleSaveEdit}>Guardar</button>
                            <button style={styles.footerBtn} onClick={() => setShowEditModal(false)}>Cancelar</button>
                        </div>
                    </div>
                </div>
            )}

            {/* MODAL: APAGAR UTILIZADOR */}
            {showDeleteModal && selectedUser && (
                <div style={styles.modalOverlay}>
                    <div style={{ ...styles.modalContent, maxWidth: '400px', textAlign: 'center' }}>
                        <h3 style={{ color: '#dc3545' }}>Eliminar Utilizador?</h3>
                        <p style={{ color: '#333' }}>Tem a certeza que deseja apagar <strong>{selectedUser.nome}</strong> permanentemente?</p>
                        <div style={styles.modalFooterCenter}>
                            <button style={{ ...styles.footerBtn, background: '#dc3545', color: 'white' }} onClick={confirmDelete}>Eliminar</button>
                            <button style={styles.footerBtn} onClick={() => setShowDeleteModal(false)}>Cancelar</button>
                        </div>
                    </div>
                </div>
            )}
            {/* --- MODAL DE SUCESSO --- */}
            {showSuccessModal && (
                <div style={{ ...styles.modalOverlay, zIndex: 2500 }}>
                    <div style={{ ...styles.modalContent, maxWidth: '400px', textAlign: 'center' }}>
                        <div style={{ color: 'green', fontSize: '16px', padding: '15px' }}>
                            <p style={{ fontSize: '40px', margin: '0 0 10px 0' }}>✅</p>
                            <strong>Sucesso!</strong>
                            <p style={{ color: '#333', marginTop: '10px', fontSize: '14px' }}>{successMessage}</p>
                        </div>
                        <div style={styles.modalFooterCenter}>
                            <button style={styles.footerBtn} onClick={() => setShowSuccessModal(false)}>Fechar</button>
                        </div>
                    </div>
                </div>
            )}

            {/* --- MODAL DE AVISO / ERRO --- */}
            {showErrorModal && (
                <div style={{ ...styles.modalOverlay, zIndex: 2500 }}>
                    <div style={{ ...styles.modalContent, maxWidth: '400px', textAlign: 'center' }}>
                        <div style={{ color: '#dc3545', fontSize: '16px', padding: '15px' }}>
                            <p style={{ fontSize: '40px', margin: '0 0 10px 0' }}>{errorMessage.includes("Por favor") || errorMessage.includes("obrigatórios") ? '⚠️' : '❌'}</p>
                            <strong style={{ color: '#333' }}>{errorMessage.includes("Por favor") || errorMessage.includes("obrigatórios") ? 'Atenção' : 'Erro na Operação'}</strong>
                            <p style={{ color: '#333', marginTop: '10px', fontSize: '14px' }}>{errorMessage}</p>
                        </div>
                        <div style={styles.modalFooterCenter}>
                            <button
                                style={{ ...styles.footerBtn, background: errorMessage.includes("Por favor") || errorMessage.includes("obrigatórios") ? '#E67E22' : '#dc3545', color: 'white', border: 'none' }}
                                onClick={() => setShowErrorModal(false)}
                            >
                                Fechar
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default UsersTable;